import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "100px 20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1 style={{ fontSize: "72px", marginBottom: "20px" }}>404</h1>
      <h2 style={{ marginBottom: "20px" }}>Oops! Page Not Found</h2>
      <p style={{ marginBottom: "30px" }}>
        The page you are looking for does not exist.
      </p>
      <Link
        to="/"
        style={{
          padding: "10px 20px",
          backgroundColor: "#003C58",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "5px",
        }}
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
